import React from "react";
import { WebhookDetailView } from "domains/webhooks/components/WebhookDetailView";

export const WebhookDetailPage: React.FC = () => {
  return <WebhookDetailView />;
};
